export default "__VITE_PUBLIC_ASSET__dbbd805f__"